import React from "react";
import Accordion from "./react-accordion/wrapper/accordion.jsx";
import AccordionPanel from "./react-accordion-panel/components/accordion-panel.jsx";
import AccordionHeading from "./react-accordion-panel/components/accordion-heading.jsx";
import AccordionBody from "./react-accordion-panel/components/accordion-body.jsx";

// /**
//  * Test: is the name of the component defined in data-react="<NAME_HERE>" attribute
//  */
export default {
	Accordion,
	AccordionPanel,
	AccordionHeading,
	AccordionBody,
	AccordionPanel: React.lazy(
		() => "./react-accordion-panel/components/accordion-panel.jsx"
	),
	Carousel: React.lazy(() =>
		import("./react-carousel/components/Carousel.jsx")
	),
	Slide: React.lazy(() => import("./react-slide/components/Slide.jsx")),
	// 	LatestPostsGrid: React.lazy(() =>
	// 		import("./latest-posts/components/effects/PostQueryComponent.jsx")
	// 	),
	LatestPostsCard: React.lazy(() =>
		import("./latest-posts/components/templates/Card.jsx")
	),
	// SampleComponentReact: React.lazy(() =>
	// 	import("./a-sample-react-block/components/SampleComponentReact.jsx")
	// ),
};
